import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.FundWalletPopupContent', {
    title: '{currencyCode} account details',
    description: 'Use the country of origin and payment amount to choose the correct option for funding your account.',
    copiedToClipboard: 'Copied to clipboard!',
});
